import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "stage-auto-jobs__list" }
const _hoisted_2 = { class: "stage-auto-jobs__hint" }
const _hoisted_3 = {
  key: 0,
  class: "stage-auto-jobs__section"
}
const _hoisted_4 = { class: "stage-auto-jobs__section-title" }
const _hoisted_5 = {
  key: 1,
  class: "stage-auto-jobs__section"
}
const _hoisted_6 = { class: "stage-auto-jobs__section-title" }
const _hoisted_7 = { class: "stage-auto-jobs__footer" }

import {
	computed,
	ref
} from "vue";
import { i18n } from "@/i18n";
import BaseModal from "@/components/common/modal/BaseModal.vue";
import AppButton from "@/components/ui-kit/button/AppButton.vue";
import AutoJobTemplateCard from "@/components/main/project-block-page/modals/AutoJobTemplateCard.vue";
import { useModalEscape } from "@/composables/useModalEscape";
import { useStageAutoJobs } from "@/composables/useStageAutoJobs";
import type { StageAutoJobsPayload } from "@/composables/useStageAutoJobs";


export default /*@__PURE__*/_defineComponent({
  __name: 'StageAutoJobsModal',
  emits: ["closed"],
  setup(__props, { expose: __expose, emit: __emit }) {

const emit = __emit;

const $modal = ref<typeof BaseModal | null>(null);
const $content = ref<HTMLElement | null>(null);

const isCalendarOpen = ref(false);

const {
	context,
	fromTemplates,
	toTemplates,
	errorsByKey,
	isSubmitting,
	canSubmit,
	init,
	reset,
	updateTemplate,
	refreshAuthors,
	refreshExecutors,
	submit,
} = useStageAutoJobs({
	onClose: () => $modal.value?.onClose()
});

const { activate: activateEsc, deactivate: deactivateEsc } = useModalEscape({
	content: $content,
	close: () => $modal.value?.onClose(),
	intercept: () => isSubmitting.value || isCalendarOpen.value
});

const title = computed(() =>
	String(i18n.global.t('autojob_dialog_title', { name: context.value?.fromStageName ?? '' })));

const onOpen = (payload: StageAutoJobsPayload) => {
	init(payload);
	isCalendarOpen.value = false;
	$modal.value?.onOpen();
	activateEsc();
};

// Закрытие без отправки отменяет смену этапа: страница вернёт в селекте прежний этап
const onModalClose = () => {
	deactivateEsc();
	reset();
	isCalendarOpen.value = false;
	emit('closed');
};

__expose({ onOpen });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, {
    ref_key: "$modal",
    ref: $modal,
    "fullscreen-on-mobile": "",
    loading: _unref(isSubmitting),
    title: title.value,
    width: "940px",
    "max-width": "95vw",
    height: "auto",
    "max-height": "90vh",
    onOnClose: onModalClose
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        ref_key: "$content",
        ref: $content,
        class: "stage-auto-jobs"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('autojob_dialog_hint')), 1),
          (_unref(fromTemplates).length)
            ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('autojob_section_from', { name: _unref(context)?.fromStageName ?? '' })), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(fromTemplates), (state) => {
                  return (_openBlock(), _createBlock(AutoJobTemplateCard, {
                    key: state.key,
                    state: state,
                    errors: _unref(errorsByKey)[state.key] ?? {},
                    onUpdate: ($event: any) => (_unref(updateTemplate)(state.key, $event)),
                    onRefreshAuthors: ($event: any) => (_unref(refreshAuthors)(state.key)),
                    onRefreshExecutors: ($event: any) => (_unref(refreshExecutors)(state.key)),
                    onCalendarToggle: _cache[0] || (_cache[0] = ($event: any) => (isCalendarOpen.value = $event))
                  }, null, 8, ["state", "errors", "onUpdate", "onRefreshAuthors", "onRefreshExecutors"]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_unref(toTemplates).length)
            ? (_openBlock(), _createElementBlock("section", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('autojob_section_to', { name: _unref(context)?.toStageName ?? '' })), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(toTemplates), (state) => {
                  return (_openBlock(), _createBlock(AutoJobTemplateCard, {
                    key: state.key,
                    state: state,
                    errors: _unref(errorsByKey)[state.key] ?? {},
                    onUpdate: ($event: any) => (_unref(updateTemplate)(state.key, $event)),
                    onRefreshAuthors: ($event: any) => (_unref(refreshAuthors)(state.key)),
                    onRefreshExecutors: ($event: any) => (_unref(refreshExecutors)(state.key)),
                    onCalendarToggle: _cache[1] || (_cache[1] = ($event: any) => (isCalendarOpen.value = $event))
                  }, null, 8, ["state", "errors", "onUpdate", "onRefreshAuthors", "onRefreshExecutors"]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "stage-auto-jobs__divider" }, null, -1)),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(AppButton, {
            label: _ctx.$t('autojob_submit'),
            disabled: !_unref(canSubmit),
            onClick: _unref(submit)
          }, null, 8, ["label", "disabled", "onClick"])
        ])
      ], 512)
    ]),
    _: 1
  }, 8, ["loading", "title"]))
}
}

})